import { render, staticRenderFns } from "./provideCommunityInfoFourth.vue?vue&type=template&id=20bdb209&scoped=true&"
import script from "./provideCommunityInfoFourth.vue?vue&type=script&lang=js&"
export * from "./provideCommunityInfoFourth.vue?vue&type=script&lang=js&"
import style0 from "./provideCommunityInfoFourth.vue?vue&type=style&index=0&id=20bdb209&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bdb209",
  null
  
)

export default component.exports